import React, { useEffect, useRef, memo } from 'react';
import PropTypes from 'prop-types';

function MarketOverviewWidget(props) {
    const container = useRef();
    const fullGraphUrl = `${document.location.origin}/informacion_de_mercado/cotizacion_emisoras`;

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js";
        script.type = "text/javascript";
        script.async = true;
        script.innerHTML = `
        {
          "colorTheme": "light",
          "dateRange": "1M",
          "showChart": true,
          "locale": ${JSON.stringify(props.locale)},
          "width": "100%",
          "height": "100%",
          "largeChartUrl": ${JSON.stringify(props.fullGraphUrl ? props.fullGraphUrl : fullGraphUrl)},
          "isTransparent": false,
          "showSymbolLogo": true,
          "showFloatingTooltip": true,
          "plotLineColorGrowing": "rgba(41, 98, 255, 1)",
          "plotLineColorFalling": "rgba(41, 98, 255, 1)",
          "gridLineColor": "rgba(46, 46, 46, 0)",
          "scaleFontColor": "rgba(15, 15, 15, 1)",
          "belowLineFillColorGrowing": "rgba(41, 98, 255, 0.12)",
          "belowLineFillColorFalling": "rgba(41, 98, 255, 0.12)",
          "belowLineFillColorGrowingBottom": "rgba(41, 98, 255, 0)",
          "belowLineFillColorFallingBottom": "rgba(41, 98, 255, 0)",
          "symbolActiveColor": "rgba(41, 98, 255, 0.12)",
          "tabs": [
            {
              "title": ${JSON.stringify(props.title)},
              "symbols": ${JSON.stringify(props.symbols)}
            }
          ],
          "customer": "bivacom"
        }
        `;
        container.current.appendChild(script);
    }, []);

    return (
        <div className={["tradingview-widget-container", props.widgetStyle].join(" ")} ref={container}>
            <div className="tradingview-widget-container__widget"></div>
            {!props.hideTVFooter ?
                <div className="tradingview-widget-copyright"><a href="https://es.tradingview.com/" rel="noopener nofollow" target="_blank"><span className="blue-text">Siga los mercados en TradingView</span></a></div>
                : null
            }
        </div>
    );
}

MarketOverviewWidget.propTypes = {
  symbols: PropTypes.arrayOf(PropTypes.exact({s: PropTypes.string})),
  title: PropTypes.string,
  locale: PropTypes.string,
  hideTVFooter: PropTypes.bool,
  widgetStyle: PropTypes.string,
  fullGraphUrl: PropTypes.string
}
 //symbols expected format ex.
//   [
//     {
//       "s":"BIVA:VMEX/19"
//     },...
//   ]

export default memo(MarketOverviewWidget);
